const template = `
  query BookingDurationResolver($input: BookingDurationResolverInput!) {
    bookingDurationResolver(input: $input)
  }
`

export default async function durationResolver(input) {
  const { bookingDurationResolver } = await request(template, { input })
  return bookingDurationResolver
}